import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'

export const getUserInfo = function (accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/userInfo`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });
}

export const getSurveyConfiguration = function (code, accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/${code}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    });
}

export const getSuppSurveyConfiguration = function (surveyId, locale, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/${pathParam}/${surveyId}/?locale=${locale}`, requestOptions);
}
